import { requestJson } from './requestJson';

export async function getAdminCreators(): Promise<{
  creators: {
    creator_id: string;
    email: string;
    display_name: string | null;
    created_at: string;
    test_count: number;
    is_admin: boolean;
  }[];
}> {
  return await requestJson('/api/admin/creators');
}
